module.exports = __webpack_public_path__ + "img/digi-btn.6b8bc84a.svg";